import { render } from "./index.vue?vue&type=template&id=1796d0aa"
const script = {}

import "./index.vue?vue&type=style&index=0&id=1796d0aa&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__